<template lang="pug">

div
  section(id="pagetitle")
     .goscontainer {{pageTitle}}

  section(id="pagecontent")
     .goscontainer
        v-row(no-gutters)
            v-col.pr-6(cols=12 md=10)
                div.editorContent(v-if="page" v-html="page.content[0].text")
            v-col.py-6(cols=12 md=2) 
                router-link.link.mb-6(
                    v-if="isNavLoaded" 
                    v-for="item in nav" 
                    :key="item.id" 
                    :to="'/page/'+item.alias") {{ item.name[0].text }}

        app-dialog-loading(v-model="loading")

</template>


<script>
    import { mapGetters } from 'vuex';
    import { pagesService } from '@/_services'

    export default {
        props: {
          alias: null
        },
        created() {
            this.$store.dispatch('page/INIT')
        },
        mounted () {
            this.loadPage(this.alias)
        },
        beforeRouteUpdate (to, from, next) {
            this.loadPage(to.params.alias)
            next()
        },
        computed: {
            ...mapGetters('page', ['nav','isNavLoaded']),
            pageTitle() {
                return this.page? this.page.title[0].text : ""
            }
        },
        methods: {
            loadPage(alias){
                this.loading = true
                pagesService.get(alias).then(data => {
                    this.page = data
                    this.setPageTitle()
                    this.loading = false
                })
            },
            setPageTitle(){
                let defaultTitle = this.page.title[0].text
                defaultTitle = this.page.title.text || defaultTitle;
                document.title = defaultTitle;
            }
        },
        data() {
            return {
                loading:true,
                page:null
            }
        }
    }
</script>

<style lang="sass" scoped>
  #pagetitle
    padding: 48px 16px 
    background-color: #E0E3E9
    color: #314369
    font-size: 36px
    font-weight: 300
    text-transform: uppercase
  #pagecontent
    padding: 48px 16px 
    background-color: #FFFFFF
    color: #000000
    .link
        font-family: $slab
        font-weight: 300
        color: #1B93AD
        text-decoration: none
        display: block
        font-size: 14px
    .link.active
        color: #505254
</style>

<style lang="scss" scoped>
.block {
  background: #F0F0F0;
  padding: 11px 32px 11px 20px;
  border-radius: 5px;
  color:#757575;
  * {
    color:#757575;
  }
}
.header-title {
  font: $app-header-title-font;
  color: $app-header-title-color;
}
</style>
<style>
  .editorContent {font-size: 14px}
  .editorContent h1 {margin:8px 0 32px 0; font-family: 'Roboto Slab', serif; font-weight: 300; font-size: 24px;}
  .editorContent h2 {margin:8px 0 24px 0; font-family: 'Roboto Slab', serif; font-weight: 300; font-size: 18px;}
  .editorContent ul {margin:20px 0; }
  .editorContent ul p {margin:0 0 5px 0;padding:0; }
  .editorContent p {margin:0 0 5px 0;padding:0; }
</style>